import styled from 'styled-components';

import { Button } from '@atom/button/button';
import { Text } from '@atom/typography/typography';

export const WrapperTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const ConnectorTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

export const WrapperCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const SaveButton = styled(Button)`
  width: 100px;
`;

export const Description = styled(Text).attrs({
  level: 'm',
  paragraph: true,
})`
  padding-top: 16px;
  width: 60%;
  min-width: 600px;
`;

export const DescriptionReadMore = styled.div`
  margin-top: 16px;
`;

export const WrapperEndpoint = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
  justify-content: space-between;
  padding: 24px 0 0 0;
`;
